/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import UpgradePricing from 'app/components/Subscription/UpgradePricing.jsx';
import LegacyPricing from 'app/components/Subscription/LegacyPricing.jsx';
import PricingMatrix from 'app/components/Subscription/PricingMatrix.jsx';
import DowngradeModal from 'app/components/Subscription/DowngradeModal.jsx';
import ConfirmationModal from 'app/components/Subscription/ConfirmationModal.jsx';
import CancellationModal from 'app/components/Subscription/Cancellation/CancellationModal.jsx';
import Loading from 'app/components/common/Loading.jsx';
import AnalyticsMixin from 'app/mixins/AnalyticsMixin.js';
import PricingModule from 'app/mixins/PricingModule.jsx';
import * as _ from 'underscore';
import { Link } from 'react-router-dom';
import { FormattedNumber } from 'react-intl';
import CreditCardModal from 'app/components/Subscription/CreditCardModal.jsx';
import EmptyState from 'app/components/common/EmptyState.jsx';
import PlanDetailBlock from 'app/components/Subscription/PlanDetailBlock.jsx';
import TDSChallengeModal from 'app/components/Subscription/TDSChallengeModal.jsx';
import { compose } from 'redux';
import ComponentWithContext from 'app/components/Routers/ComponentWithContext.jsx';
import UserMessages from 'app/modules/UserMessageModule.js';

class Subscription extends React.Component {
	constructor(props) {
		super(props);

		let changePlanOpen = false,
			requestedPlan = 0;

		if (window.location.search !== '') {
            let matches = window.location.search.match(/change=true/);
            if (matches !== null) {
                changePlanOpen = true;
            }

        }

		if (requestedPlan === 0 && this.props.user.detail.pubLevel) {
			requestedPlan = this.props.user.detail.pubLevel;
		}

		this.state = {
			subscription: {
				level: requestedPlan,
				addOns: 0,
				term: 1
			},
			changePlanOpen,
			errors: null,
			trackingAction: '',
			callUpdatePlan: false,
			challengeModal: false,
			requestData: null,
			requestMethod: null
		};

		this.planChange = React.createRef();

		this.checkForRedirect = this.checkForRedirect.bind(this);
		this.updateSubscriptionAddOns = this.updateSubscriptionAddOns.bind(this);
		this.changePlan = this.changePlan.bind(this);
		this.updatePlan = this.updatePlan.bind(this);
		this.createSubscription = this.createSubscription.bind(this);
		this.setPlan = this.setPlan.bind(this);
		this.setTerm = this.setTerm.bind(this);
		this.plusUpgrade = this.plusUpgrade.bind(this);
		this.togglePlanChange = this.togglePlanChange.bind(this);
		this.closePlanChange = this.closePlanChange.bind(this);
		this.restartPlan = this.restartPlan.bind(this);
		this.showCreditCardModal = this.showCreditCardModal.bind(this);
		this.cancelPlan = this.cancelPlan.bind(this);
		this.setRequestParams = this.setRequestParams.bind(this);
		this.promoClick = this.promoClick.bind(this);

	}

	componentDidMount() {

		if (typeof zE !== 'undefined') {
			zE(function() {
				zE.hide();
			});
		}

		if ((mixpanel || this.props.recordEvent) && this.props.router.location.pathname.match(/\/account\/subscription\??/)) {
			mixpanel.track("Subscription Page Loaded");

			if (this.props.recordEvent) {
				this.props.recordEvent({
					pub_id: this.props.user.detail.id,
					event_name: 'Subscription Page Loaded',
					event_data: {

					}
				});
			}
		}

		this.props.getSubscription();
		this.props.getPlanDetail(this.props.user.detail.pubLevel);
		this.props.getPlans();

	}

	componentDidUpdate(prevProps, prevState) {

		this.checkForRedirect(this.props);

		let subscription = this.state.subscription,
			nextModal = null,
			variant = '',
			addOnPrice = null,
			products = [],
			trackingAction = this.state.trackingAction,
			errors = [],
			constants = this.props.app.config.constants,
			requestData = this.state.reqeustData,
			requestMethod = this.state.requestMethod,
			challengeModal = this.state.challengeModal;

		if (this.state.selectedPlan === 0 && this.props.user.detail.pubLevel) {
			subscription.level = this.props.user.detail.pubLevel;
			this.setState({
				subscription
			});
		}

		if (this.props.user.detail.isAgent) {
			return;
		}

		if (prevProps.app.loading.SUB_FETCH === true && this.props.app.loading.SUB_FETCH === false) {
			subscription.addOns = (this.props.plans.current.addOns !== undefined && this.props.plans.current.addOns.add_on_social !== undefined) ? this.props.plans.current.addOns.add_on_social.qty : 0;
			subscription.term = parseInt(this.props.plans.current.planTerm);
		}

		if (this.state.changePlanOpen) {
			if (this.planChange.current) {
				this.planChange.current.scrollIntoView(true);
			}
		}

		if ((prevProps.app.loading.SUB_UPDATE === true && this.props.app.loading.SUB_UPDATE === false) ||
			(prevProps.app.loading.SUB_ADDON_UPDATE === true && this.props.app.loading.SUB_ADDON_UPDATE === false)) {
			// fetch fresh perms and updated user just in case a user updated their twitter post limit
			this.props.getUserPerms();
			this.props.getUser();
		}

		if (prevProps.app.loading.SUB_PAUSE_SUBSCRIPTION === true && this.props.app.loading.SUB_PAUSE_SUBSCRIPTION === false) {
			if (this.props.plans.subscriptionPaused !== 'paused') {
				this.props.getUserPerms();
				this.props.getUser();
			}
			this.props.closeAllModals();
		}

		if (prevProps.app.loading.SUB_APPLY_COUPON === true && this.props.app.loading.SUB_APPLY_COUPON === false) {
			let couponErrors = this.props.getApiErrors(['SUB_APPLY_COUPON']);
			// this particular coupon error is handled in DiscountOffer.jsx
			if (!couponErrors.length) {
				this.props.addMessage(UserMessages.generateFlashMessage("Enjoy your discount and maximizing your social media posting.", "SUB_APPLY_COUPON"));
				this.props.closeAllModals();
			}
		}

		if (prevProps.app.loading.SUB_PAUSE_SUBSCRIPTION === true && this.props.app.loading.SUB_PAUSE_SUBSCRIPTION === false) {
			let couponErrors = this.props.getApiErrors(['SUB_PAUSE_SUBSCRIPTION']);
			// this particular coupon error is handled in PauseOption.jsx
			if (!couponErrors.length) {
				this.props.closeAllModals();
			}
		}

		if (prevState.callUpdatePlan === false && this.state.callUpdatePlan === true) {
			this.updatePlan();
			this.setState({
				callUpdatePlan: false
			});
		}

		errors = this.props.getApiErrors(['SUB_UPDATE', 'SUB_ADDON_UPDATE', 'SUB_CREATE']);

		if (errors.length && this.state.errors === null) {
			this.props.closeAllModals();
            if (mixpanel) {
                mixpanel.track('Subscription Update Error', {
                    error: JSON.stringify(errors[0].errors)
                });
            }

			if (this.props.recordEvent) {
				this.props.recordEvent({
					pub_id: this.props.user.detail.id,
					event_name: 'Subscription Update Error',
					event_data: {
						error: JSON.stringify(errors[0].errors)
					}
				});
			}

			if (errors[0].errors !== undefined &&
				errors[0].errors.subscription !== undefined &&
				errors[0].errors.subscription.TDSChallenge !== undefined &&
				errors[0].errors.subscription.TDSChallenge !== null &&
				!this.state.challengeModal)
			{
				this.setState({
					challengeModal: true
				});
				this.props.addModal(
					<TDSChallengeModal
						{...this.props}
						TDSChallenge={errors[0].errors.subscription.TDSChallenge}
						requestData={this.state.requestData}
						requestMethod={this.state.requestMethod}/>
				);
			}

			this.setState({
				errors: errors[0]
			});

			this.props.deleteApiError(['SUB_UPDATE', 'SUB_ADDON_UPDATE', 'SUB_CREATE']);

			return;
		}

		// new sub else updated sub
		if (this.props.isFreeUser(prevProps.user.detail.pubLevel) && !this.props.isFreeUser()) {
			this.props.getUser();
			this.props.getUserPerms();

			this.props.closeAllModals();

            if (mixpanel) {
                mixpanel.track('Subscription Created', {
                    'name': this.props.plans.current.planName
                });
            }

			// if (dataLayer) {
            //     products.push({
            //         'name': this.props.plans.current.planName,     // Name or ID is required.
            //         'price': this.props.plans.current.price,
            //         'quantity': 1,
            //         'variant': 'new'
            //     });
			//
            //     dataLayer.push({
            //         'event': 'purchase',
            //         'ecommerce': {
            //             'purchase': {
            //                 'actionField': {
            //                     'id': this.props.plans.current.uuid, // Transaction ID. Required for purchases and refunds.
            //                     'revenue': this.props.plans.current.price
            //                 },
            //                 'products': products
            //             }
            //         },
			// 		// GA4 params
			// 		'transaction_id': this.props.plans.current.uuid,
			// 		'value': 1.00,
			// 		items: [
			// 			{
			// 				item_id: 'dlvrit_1',
			// 				item_name: 'dlvr.it premium plan',
			// 				price: 1.00,
			// 				quantity: 1
			// 			}
			// 		]
            //     });
            // }

			if (gtag) {
				let promoData = this.props.getPersistedData('gaPromo');

				gtag('event', 'purchase', {
					transaction_id: this.props.plans.current.uuid,
					value: 1.00,
					currency: 'USD',
					items: [
						{
							item_id: 'dlvrit_1',
							item_name: 'dlvr.it premium plan',
							item_variant: 'New Plan',
							price: 1.00,
							quantity: 1,
							promotion_id: (promoData && promoData.promotion_id) ? (promoData.promotion_id) : '',
			                promotion_name: (promoData && promoData.promotion_name) ? (promoData.promotion_name) : ''
						}
					],
				});

				if (this.props.recordEvent) {
					this.props.recordEvent({
						pub_id: this.props.user.detail.id,
						event_name: 'New Plan Purchase',
						event_data: {
							promotion_id: (promoData && promoData.promotion_id) ? (promoData.promotion_id) : '',
			                promotion_name: (promoData && promoData.promotion_name) ? (promoData.promotion_name) : ''
						}
					})
				}

				this.props.clearPersistedData('gaPromo');
			}

			nextModal = (
                <ConfirmationModal
					{...this.props}
                    confirmationType="newpaidsubscription"
                    confirmationAction={this.props.closeAllModals}
                    planLevel={this.props.plans.current.planLevel}
                    planTerm={this.props.plans.current.planTerm} />
			);

			this.props.addModal(nextModal);

		} else if ((!_.isEmpty(prevProps.plans.current) && !_.isEqual(prevProps.plans.current, this.props.plans.current)) ||
					(!prevProps.user.detail.subscriptionState === constants.SUBSCRIPTION_ACTIVE && this.props.user.detail.subscriptionState === constants.SUBSCRIPTION_CANCELLED)) {
			this.props.getUser();
			this.props.getUserPerms();
			this.props.closeAllModals();

			// reset any 3DS challenge related variables
			requestData = null;
			requestMethod = null;

			if (challengeModal) {
				challengeModal = false;
				this.props.closeAllModals();
				this.setState({
					errors: null
				});
			}

			if (dataLayer !== undefined || mixpanel !== undefined || gtag !== undefined) {
				switch (this.state.trackingAction) {
					case 'planupgrade':
					case 'downgrade':
					case 'termchange':
						mixpanel.track('User Initiated Plan Change', {
							'old-plan-name': AnalyticsMixin.getPlanLabel(prevProps.user.detail.pubLevel, prevProps.plans.current.planTerm),
							'new-plan-name': AnalyticsMixin.getPlanLabel(this.props.plans.current.planLevel, this.props.plans.current.planTerm)
						});
						dataLayer.push({
							'event': 'plan-change',
							'old-plan-name': AnalyticsMixin.getPlanLabel(prevProps.user.detail.pubLevel, prevProps.plans.current.planTerm),
							'new-plan-name': AnalyticsMixin.getPlanLabel(this.props.plans.current.planLevel, this.props.plans.current.planTerm)
						});
						if (this.state.trackingAction === 'planupgrade' || this.state.trackingAction === 'termchange') {
							if (this.state.trackingAction === 'planupgrade') {
								products.push({
									'name': AnalyticsMixin.getPlanLabel(this.props.plans.current.planLevel, this.props.plans.current.planTerm),
									'price': this.props.plans.details[this.props.plans.current.planLevel].price[this.props.plans.current.planTerm],
									'quantity': 1,
									'variant': 'upgrade plan'
								});
							} else {
								variant = 'term change';
								products.push({
									'name': AnalyticsMixin.getPlanLabel(this.props.plans.current.planLevel, this.props.plans.current.planTerm),
									'price': this.props.plans.details[this.props.plans.current.planLevel].price[this.props.plans.current.planTerm],
									'quantity': 1,
									'variant': 'term change'
								});
							}

							// dataLayer.push({
					        //     'event': 'purchase',
					        //     'ecommerce': {
							// 		'purchase': {
							// 			'actionField': {
							// 				'id': this.props.plans.current.uuid,   // Transaction ID. Required for purchases and refunds.
							// 				'revenue': products[0].price                 // Total transaction value (incl. tax and shipping)
							// 			},
							// 			'products': products
							// 		}
					        //     }
					        // });

							if (gtag) {
								let txID = '',
									promoData = this.props.getPersistedData('gaPromo');

								if (this.state.trackingAction === 'planupgrade') {
									txID = this.props.plans.current.uuid + "_planupgrade_" + new Date().getTime();
									gtag('event', 'purchase', {
										transaction_id: txID,
				                        value: 1.00,
				                        currency: 'USD',
				                        items: [
				                            {
				                                item_id: 'dlvrit_1',
				    	                        item_name: 'dlvr.it premium plan',
				                                item_variant: 'Plan Upgrade',
				    	                        price: 1.00,
				    	                        quantity: 1,
												promotion_id: (promoData && promoData.promotion_id) ? (promoData.promotion_id) : '',
								                promotion_name: (promoData && promoData.promotion_name) ? (promoData.promotion_name) : ''
				                            }
				                        ],

									});
								} else {
									txID = this.props.plans.current.uuid + "_termchange_" + new Date().getTime();
									gtag('event', 'purchase', {
										transaction_id: txID,
				                        value: 1.00,
				                        currency: 'USD',
				                        items: [
				                            {
				                                item_id: 'dlvrit_1',
				    	                        item_name: 'dlvr.it premium plan',
				                                item_variant: 'Term Change',
				    	                        price: 1.00,
				    	                        quantity: 1,
												promotion_id: (promoData && promoData.promotion_id) ? (promoData.promotion_id) : '',
								                promotion_name: (promoData && promoData.promotion_name) ? (promoData.promotion_name) : ''
				                            }
				                        ],

									});
								}
							}
						}


						break;

					case 'addons':
						let sign = "+";

						variant = 'addon upgrade';
						addOnPrice = this.props.plans.details[this.props.plans.current.planLevel].addOnPrices[this.props.plans.current.planTerm];

						if (this.props.plans.current.addOns) {
							if (_.isObject(this.props.plans.current.addOns.add_on_social) && _.isObject(prevProps.plans.current.addOns.add_on_social)) {
								if (prevProps.plans.current.addOns.add_on_social.qty < this.props.plans.current.addOns.add_on_social.qty) {
									sign = "-";
									variant = 'addon downgrade';
								}
							}
						}

						if (mixpanel) {
							mixpanel.track('User Add-on Change', {
								'plan-name': AnalyticsMixin.getPlanLabel(this.props.plans.current.planCode, this.props.plans.current.planTerm),
								'add-on-change': [sign, this.props.plans.current.addOns].join("")
							});
						}

						dataLayer.push({
							'event': 'plan-addon-change',
							'plan-name': AnalyticsMixin.getPlanLabel(this.props.plans.current.planCode, this.props.plans.current.planTerm),
							'add-on-change': [sign, this.props.plans.current.addOns].join("")
						});

						if (sign === "+") {
							products.push({
								'name': 'Add On',
								'price': addOnPrice,
								'quantity': this.props.plans.current.addOns,
								'variant': variant
							});

							// dataLayer.push({
					        //     'event': 'purchase',
					        //     'ecommerce': {
							// 		'purchase': {
							// 			'actionField': {
							// 				'id': this.props.plans.current.uuid,  // Transaction ID. Required for purchases and refunds.
							// 				'revenue': addOnPrice * this.state.subscription.addOns  // Total transaction value (incl. tax and shipping)
							// 			},
							// 			'products': products
							// 		}
					        //     }
					        // });

							if (gtag) {
								let promoData = this.props.getPersistedData('gaPromo');

								gtag('event', 'purchase', {
									transaction_id: this.props.plans.current.uuid + '_addonpurchase_' + new Date().getTime(),
									value: 1.00,
									currency: 'USD',
									items: [
										{
											item_id: 'dlvrit_1',
											item_name: 'dlvr.it premium plan',
											item_variant: 'Add-On Purchase',
											price: 1.00,
											quantity: 1,
											promotion_id: (promoData && promoData.promotion_id) ? (promoData.promotion_id) : '',
							                promotion_name: (promoData && promoData.promotion_name) ? (promoData.promotion_name) : ''
										}
									],

								});

								if (this.props.recordEvent) {
									this.props.recordEvent({
										pub_id: this.props.user.detail.id,
										event_name: 'Add-On Purchase',
										event_data: {
											'plan-name': AnalyticsMixin.getPlanLabel(this.props.plans.current.planCode, this.props.plans.current.planTerm),
											'add-on-change': [sign, this.props.plans.current.addOns].join(""),
											promotion_id: (promoData && promoData.promotion_id) ? (promoData.promotion_id) : '',
							                promotion_name: (promoData && promoData.promotion_name) ? (promoData.promotion_name) : ''
										}
									});
								}

								this.props.clearPersistedData('gaPromo');
							}
						}
						break;

					case 'addonposts':
						let action = "Increase";
						if (_.isObject(prevProps.plans.current.addOns.add_on_posts_1) &&
							prevProps.plans.current.addOns.add_on_posts_1.qty > this.props.plans.current.addOns.add_on_posts_1.qty) {
							action = "Decrease";
						}
						if (this.props.recordEvent) {
							this.props.recordEvent({
								pub_id: this.props.user.detail.id,
								event_name: `Add On Posts ${action}`,
								event_data: {
									quantity: this.props.plans.current.addOns.add_on_posts_1.qty
								}
							});
						}
						break;

					default:
						break;
				}

			}

			// remove the change=true on updated subscription
			if (window.location.search.match(/change=true/)) {
				window.location.search = '';
			}

			if (this.props.router.location.pathname.match(/plus$/)) {
				this.props.router.navigate('/account/subscription');
			}

			this.setState({
				trackingAction: '',
				requestData,
				requestMethod,
				challengeModal
			});

		}

	}

	componentWillUnmount() {

		if (typeof zE !== 'undefined') {
			zE(function() {
				zE.show();
			});
		}

	}

	checkForRedirect(props) {

		let constants = this.props.app.config.constants;

		if (props.router.query && props.router.query.subscribe) {
			// can't directly set or clear the query string, but leave the code here
			// when it could in case i have a bug to fix
			//props.router.location.search = '';
			this.showCreditCardModal();
		}

		if (this.props.isFreeUser(props.user.detail.pubLevel)) {
			if (props.router.location.pathname == "/account/subscription/plus") {
				this.props.router.navigate('/account/subscription/new?plan=9');
			} else if (props.router.location.pathname == "/account/subscription") {
				this.props.router.navigate('/account/subscription/new');
			}
		} else {
			if (this.props.isPlusUser(props.user.detail.pubLevel) || this.props.isAgencyPlusUser(props.user.detail.pubLevel)) {
				if (props.router.location.pathname == "account/subscription/plus") {
					this.props.router.navigate('account/subscription');
				}
			}
		}

		if (window.location.search !== '') {
            let matches = window.location.search.match(/change=true/);
            if (matches !== null && !this.state.changePlanOpen) {
                this.setState({
					changePlanOpen: true
				});
            }
        }

	}

	updateSubscriptionAddOns(data) {
		let subscription = this.state.subscription,
			trackingAction = 'addons';

		this.props.updateAddOns(data);

		if (data.add_on_social !== undefined) {
			subscription.addOns = data.add_on_social;
		} else if (data.add_on_posts_1 !== undefined) {
			subscription.addOnPosts = data.add_on_posts_1;
			trackingAction = 'addonposts';
		}

		this.setState({
			trackingAction,
			subscription,
			// store what we did in case we have to do it again after
			// a 3DS challenge
			requestData: data,
			requestMethod: this.props.updateAddOns
		});

	}

	changePlan(data) {

		let subscription = this.state.subscription;

		this.props.deleteApiError(['SUB_UPDATE', 'SUB_ADDON_UPDATE']);

		this.props.updateSubscription(data);

		// store what we did in case we have to do it again after
		// a 3DS challenge
		this.setState({
			requestData: data,
			requestMethod: this.props.updateSubscription
		});

		if (data.trackingAction) {
			if (data.trackingAction !== "downgrade") {
				this.props.getPlanDetail(subscription.level);
			}
			if (data.add_on_social) {
				subscription.addOns = data.add_on_social;
			}
			if (data.level) {
				subscription.level = data.level;
			}
			if (data.term) {
				subscription.term = data.term;
			}
			this.setState({
				trackingAction: data.trackingAction,
				subscription,
				errors: null
			});
		}

	}

	updatePlan(e) {

		let subscription = this.state.subscription,
			selectedPlan = this.state.subscription.level,
			nextModal = null,
			constants = this.props.app.config.constants,
			nextPlan = this.props.plans.details[this.state.subscription.level],
			adjustedAddOns = 0,
			newLimits = null,
			currentPlan = parseInt(this.props.plans.current.planLevel);

		this.props.deleteApiError(['SUB_UPDATE', 'SUB_ADDON_UPDATE']);

		if (e) {
			e.preventDefault();
		}

		if ((this.props.isPlusUser(selectedPlan) && this.props.isProUser(currentPlan)) ||
			(this.props.isAgencyPlusUser(selectedPlan) && this.props.isAgencyUser(currentPlan)) ||
			(this.props.isProUser(selectedPlan) && this.props.isPlusUser(currentPlan)) ||
			(this.props.isAgencyUser(selectedPlan) && this.props.isAgencyPlusUser(currentPlan)) ||
			(this.props.isUltimateUser(selectedPlan) && this.props.isPlusUser(currentPlan))) {
			if (this.props.plans.current.addOns && this.props.plans.current.addOns.add_on_social) {
				adjustedAddOns = this.props.getAdjustedAddOns(selectedPlan);
				newLimits = this.props.calculateAddOns([{
					addOn: constants.SUBSCRIPTION_ADDON_SOCIALS,
					quantity: adjustedAddOns
				}], nextPlan);
				subscription.addOns = adjustedAddOns;
				this.setState({
					subscription
				});
			}
		}

		// downgrade in process
		if (!this.props.isUpgrade(selectedPlan) || this.props.isFreeUser(selectedPlan)) {
			nextModal = (
				<CancellationModal
					{...this.props}
					newPlanLevel={selectedPlan}
					newPlanTerm={this.state.subscription.term}
					router={this.props.router}
					planChangeHandler={this.changePlan}
					adjustedAddOns={adjustedAddOns} />
			);
		} else {
			nextModal = (
				<ConfirmationModal
					{...this.props}
					confirmationType="planupgrade"
					subscription={this.props.plans.current}
					planLevel={selectedPlan}
					planTerm={this.state.subscription.term}
					confirmationAction={this.changePlan}
					adjustedAddOns={adjustedAddOns}
					newLimits={newLimits} />
			);
		}

		if (nextModal !== null) {
			this.props.addModal(nextModal);
			this.setState({
				errors: null
			});
		}

	}

	createSubscription(e) {
		e.preventDefault();

		this.showCreditCardModal();

	}

	setTerm(e) {
		let subscription = this.state.subscription;

		subscription.term = parseInt(e.currentTarget.dataset.term, 10);
		this.setState({
			subscription
		});

	}

	setPlan(e) {

		let nextPlan = parseInt(e.currentTarget.dataset.plan, 10),
			subscription = this.state.subscription,
			constants = this.props.app.config.constants,
			planError = this.state.planError,
			limits = null;

		subscription.level = nextPlan;

		// check that usage doesn't outstrip the plan unless the user is upgrading to plus
		// in which case we carry over the add-ons
		if (!this.props.isFreeUser(nextPlan) && (this.props.isPlusUser(nextPlan) || this.props.isAgencyPlusUser(nextPlan))) {
			limits = this.props.plans.details[nextPlan].limits;
			if (parseInt(limits.hardLimitInputs, 10) < (parseInt(this.props.user.perms.perms.hardLimitInputs, 10) - this.props.user.perms.resources.inputsAvailable) ||
				parseInt(limits.hardLimitOutputs, 10) < (parseInt(this.props.user.perms.perms.hardLimitOutputs, 10) - this.props.user.perms.resources.outputsAvailable)) {
				subscription.level = this.props.plans.current.planLevel;
				planError = "Changing your plan wouldn't support your current usage.";
			} else {
				planError = '';
			}
		} else {
			planError = '';
		}

		// GA4 commerce events
		// if (dataLayer) {
		// 	let planData = GetPlanData.lookupDetails(
		// 		subscription.level,
		// 		subscription.term
		// 	);
		// 	dataLayer.push({
		// 		'event': 'begin_checkout',
		// 		'currency': 'USD',
		// 		'value': planData.price,
		// 		'items': [{
		// 			item_id: planData.plan_id,
        //             item_name: planData.plan_name,
        //             price: planData.price,
        //             item_variant: 'plan_change',
        //             quantity: 1
		// 		}]
		// 	});
		// }

		if (gtag) {
			let promoData = this.props.getPersistedData('gaPromo');

			gtag('event', 'begin_checkout', {
				currency: 'USD',
				value: 1.0,
				items: [{
					item_id: 'dlvrit_1',
					item_name: 'dlvr.it premium plan',
					item_variant: 'Plan Change',
					price: 1.0,
					quantity: 1,
					promotion_id: (promoData && promoData.promotion_id) ? (promoData.promotion_id) : '',
	                promotion_name: (promoData && promoData.promotion_name) ? (promoData.promotion_name) : ''
				}],
			});
		}

		this.setState({
			subscription,
			planError
		});

	}

	plusUpgrade(e, newLevel) {
		let subscription = this.state.subscription;
		subscription.level = newLevel;

		this.setState({
			subscription
		}, function() {
			this.updatePlan();
		});

	}

	togglePlanChange(e) {
		if (e.currentTarget.dataset.source !== undefined && e.currentTarget.dataset.source === 'promo') {
			if (this.state.changePlanOpen) {
				return;
			}
		}

		this.setState({
			changePlanOpen: !this.state.changePlanOpen
		});
	}

	closePlanChange() {
		this.setState({
			changePlanOpen: false
		});
	}

	cancelPlan(e) {

		let constants = this.props.app.config.constants,
			subscription = this.state.subscription;

		if (e) {
			e.preventDefault();
		}

		subscription.level = constants.PUB_LEVEL_1;
		subscription.term = constants.SUBSCRIPTION_TERM_MONTHLY;

		this.setState({
			subscription,
			callUpdatePlan: true
		});

	}

	restartPlan(e) {

		let constants = this.props.app.config.constants,
			subscription = this.state.subscription;

		if (e) {
			e.preventDefault();
		}

		subscription.level = this.props.user.detail.pubLevel;

		this.setState({
			subscription,
			callUpdatePlan: true
		});

	}

	showCreditCardModal(e) {
		let modalTerm = (this.state.subscription.term) ? this.state.subscription.term : constants.SUBSCRIPTION_TERM_ANNUAL,
			ccModal = null,
			addOns = {};

		if (this.props.plans.current.planLevel == this.state.subscription.level) {
			if (this.props.plans.current.addOns) {
				if (this.props.plans.current.addOns.add_on_social) {
					if (this.props.plans.current.addOns.add_on_social.qty) {
						addOns = {
							add_on_social: this.props.plans.current.addOns.add_on_social.qty
						};
					}
				}
			}
			if (_.isEmpty(addOns) && this.state.subscription.addOns) {
				addOns = {
					add_on_social: this.state.subscription.addOns
				};
			}
		}

		ccModal = (
			<CreditCardModal
				{...this.props}
				plan={this.state.subscription.level}
				planTerm={modalTerm}
				planPrice={0}
				username={this.props.user.detail.username}
				router={this.props.router}
				action={'subscribe'}
				errors={this.state.errors}
				changeTerm={this.setTerm}
				closeAction={this.props.closeAllModals}
				addOns={addOns} />
		);
	}

	setRequestParams(method, data) {
		this.setState({
			requestMethod: method,
			requestData: data
		});
	}

	promoClick(e) {
		e.preventDefault();

		let nextSubscription = this.state.subscription,
			constants = this.props.app.config.constants;

		nextSubscription.level = constants.PUB_LEVEL_6;

		this.setState({
			subscription: nextSubscription
		}, () => {
			this.updatePlan();
		})
	}

	render() {
		let constants = this.props.app.config.constants,
			content = null,
			legacyPlans = [
				constants.PUB_LEVEL_3,
				constants.PUB_LEVEL_4,
				constants.PUB_LEVEL_5,
			],
			comparisonLink = null,
			pubLevel = parseInt(this.props.user.detail.pubLevel),
			changePlanBlock = null,
			changePlanChevron = null,
			planRadioBlock = null,
			termChangeBlock = null,
			termChangeCopy = null,
			termLabel = '',
			newTerm = 0,
			planChangeButtonLabel = 'Change your base plan',
			planChangeLabel = 'You are here',
			planChangeAction = null,
			planChangeButtonClass = 'btn-flat plan-change-button',
			cancelBlock = null,
			modalTerm = 0,
			addOns = null,
			planError = '',
			savingsPct = 25,
			iconGrid = (
				<div className="icon-grid-wrapper">
					<ul className="icon-grid">
						<li className="grid-icon facebook">
							<i className="fa fa-facebook"></i>
						</li>
						<li className="grid-icon facebook">
							<i className="fa fa-facebook"></i>
						</li>
						<li className="grid-icon linkedin">
							<i className="fa fa-linkedin"></i>
						</li>
						<li className="grid-icon linkedin">
							<i className="fa fa-linkedin"></i>
						</li>
					</ul>
				</div>
			);

		comparisonLink = (
			<div className="other-plans">
				<Link to="/account/subscription/compare">Compare our plans</Link>
			</div>
		);

		if (this.props.user.detail.isAgent) {
			return (
				<div className="app-column content main">
					<main className="content-container">
						<EmptyState
							message="Sorry, only the account owner can access this page."/>
					</main>
				</div>
			);
		}

		if (this.props.user.detail.pubLevel === constants.PUB_LEVEL_6) {
			savingsPct = 28;
		}

		if (!_.isEmpty(this.props.plans.current)) {
			if (this.props.plans.current.planTerm != constants.SUBSCRIPTION_TERM_TRIAL) {
				if (this.props.plans.current.planTerm == constants.SUBSCRIPTION_TERM_ANNUAL) {
					termChangeCopy = "Switch to monthly billing";
					termLabel = "month";
					newTerm = constants.SUBSCRIPTION_TERM_MONTHLY;
				} else {
					termChangeCopy = "Save {savingsPct}% when you change to annual billing";
					termLabel = "year";
					newTerm = constants.SUBSCRIPTION_TERM_ANNUAL;
				}
				termChangeBlock = (
					<div className="change-plan-term">
						<a href="#" onClick={(e) => {
								this.props.changeTerm(e, this.setRequestParams);
							}} data-term={newTerm}>{termChangeCopy}</a>
					</div>
				);

				// hide the term change link for non-legacy users who are on monthly (there's a big button for them)
				if (legacyPlans.indexOf(parseInt(this.props.user.detail.pubLevel)) === -1 &&
					this.props.plans.current.planTerm !== constants.SUBSCRIPTION_TERM_ANNUAL) {
					termChangeBlock = null;
				}
			}
		}

		if (!_.isEmpty(this.props.plans.details) && !_.isEmpty(this.props.plans.current)) {
			if (this.props.plans.current.planTerm == constants.SUBSCRIPTION_TERM_TRIAL) {
				planChangeButtonLabel = "Start your plan";
			}
		}


		if (this.state.changePlanOpen && !_.isEmpty(this.props.plans.details) && !_.isEmpty(this.props.plans.current)) {
			changePlanChevron = (<i className="icon ion-chevron-down"/>);
			let setPlanChange = (type) => {
				planChangeAction = this.updatePlan;
				if (type == 'downgrade') {
					planChangeLabel = "Downgrade your plan";
					planChangeButtonClass += ' downgrade';
				} else {
					planChangeLabel = "Upgrade your plan";
					planChangeButtonClass += ' upgrade';
				}
			}
			if (this.props.plans.current.planTerm == constants.SUBSCRIPTION_TERM_TRIAL) {
				planChangeLabel = "Upgrade";
				planChangeAction = this.updatePlan;
				planChangeButtonClass += ' upgrade';
			} else {
				if (legacyPlans.indexOf(this.props.user.detail.pubLevel) !== -1) {
					if (this.props.isFreeUser(this.state.subscription.level)) {
						setPlanChange('downgrade');
					} else {
						setPlanChange('upgrade');
					}
				} else {
					// can't go lower than starter other than shutting it down
					if (this.props.isUpgrade(this.state.subscription.level)) {
						setPlanChange('upgrade');
					} else if (this.state.subscription.level !== this.props.user.detail.pubLevel) {
						setPlanChange('downgrade');
					}
				}
			}

			let planRadioError = null;

			if (this.state.planError) {
				planRadioError = (
					<div className="plan-radios-error">
						{this.state.planError}
					</div>
				);
			}

			planRadioBlock = (
				<div className="plan-radios-wrapper">
					{planRadioError}
					<div className="plan-radios">
						<div className="plan-radio" data-plan={constants.PUB_LEVEL_16} onClick={this.setPlan}>
							<div className="control-wrapper">
								<input type="radio" value={constants.PUB_LEVEL_16} checked={this.state.subscription.level === constants.PUB_LEVEL_16} data-plan={constants.PUB_LEVEL_16} onChange={this.setPlan}/> Starter (Up to 2 social networks.)
							</div>
							<div className={"extra-info " + ((this.props.isStarterUser(this.state.subscription.level)) ? '' : 'hidden')}>
								<div className="arrow-down"></div>
								<div className="extra-info-headline">
									Includes:
								</div>
								<div className="extra-info-features">
									<div className="extra-info-feature">
										<i className="fa fa-share"></i> Feeds
									</div>
									<div className="extra-info-feature">
										<i className="fa fa-list"></i> Queue
									</div>
									<div className="extra-info-feature">
										<i className="fa fa-bar-chart"></i> Stats
									</div>
								</div>
							</div>
						</div>
						<div className="plan-radio" data-plan={constants.PUB_LEVEL_15} onClick={this.setPlan}>
							<div className="control-wrapper">
								<input type="radio" value={constants.PUB_LEVEL_15} checked={this.state.subscription.level === constants.PUB_LEVEL_15} data-plan={constants.PUB_LEVEL_15} onChange={this.setPlan}/> Basic (Up to 3 social networks.)
							</div>
							<div className={"extra-info " + ((this.props.isBasicUser(this.state.subscription.level)) ? '' : 'hidden')}>
								<div className="arrow-down"></div>
								<div className="extra-info-headline">
									Includes:
								</div>
								<div className="extra-info-features">
									<div className="extra-info-feature">
										<i className="fa fa-share"></i> Feeds
									</div>
									<div className="extra-info-feature">
										<i className="fa fa-list"></i> Queue
									</div>
									<div className="extra-info-feature">
										<i className="fa fa-bar-chart"></i> Stats
									</div>
								</div>
							</div>
						</div>
						<div className="plan-radio" data-plan={constants.PUB_LEVEL_6} onClick={this.setPlan}>
							<div className="control-wrapper">
								<input type="radio" value={constants.PUB_LEVEL_6} checked={this.props.isProUser(this.state.subscription.level)} data-plan={constants.PUB_LEVEL_6} onChange={this.setPlan}/> Pro (10 socials. 50 feeds.)
							</div>
							<div className={"extra-info " + ((this.state.subscription.level === constants.PUB_LEVEL_6) ? '' : 'hidden')}>
								<div className="arrow-down"></div>
								<div className="extra-info-headline">
									Includes all the features of Basic and:
								</div>
								<div className="extra-info-features">
									<div className="extra-info-feature">
										{iconGrid} Multiple profiles per social network
									</div>
									<div className="extra-info-feature">
										<i className="icon ion-reply-all reverse" /> Echo: Power Schedule Content
									</div>
									<div className="extra-info-feature">
										<i className="icon ion-paper-airplane"></i> Faster feed updates
									</div>
								</div>
							</div>
						</div>
						<div className="plan-radio" data-plan={constants.PUB_LEVEL_9} onClick={this.setPlan}>
							<div className="control-wrapper">
								<input type="radio" value={constants.PUB_LEVEL_9} checked={this.props.isPlusUser(this.state.subscription.level)} data-plan={constants.PUB_LEVEL_9} onChange={this.setPlan}/> Plus (15 socials. 75 feeds.)
							</div>
							<div className={"extra-info " + ((this.state.subscription.level === constants.PUB_LEVEL_9) ? '' : 'hidden')}>
								<div className="arrow-down"></div>
								<div className="extra-info-headline">
									Includes all the features of Pro and:
								</div>
								<div className="extra-info-features">
									<div className="extra-info-feature">
										<i className="ds-icon icon-everqueue"></i> Everqueue: Recycle Content
									</div>
									<div className="extra-info-feature">
										<i className="icon ion-flash"></i> Content Search & Bulk Import
									</div>
									<div className="extra-info-feature">
										<i className="icon ion-ios-pricetag"></i> Categories
									</div>
								</div>
							</div>
						</div>
						<div className="plan-radio" data-plan={constants.PUB_LEVEL_8} onClick={this.setPlan}>
							<div className="control-wrapper">
								<input type="radio" value={constants.PUB_LEVEL_8} checked={this.props.isAgencyUser(this.state.subscription.level)} data-plan={constants.PUB_LEVEL_8} onChange={this.setPlan}/> Agency (250 socials. 1500 feeds.)
							</div>
							<div className={"extra-info " + ((this.props.isAgencyUser(this.state.subscription.level)) ? '' : ' hidden')}>
								<div className="arrow-down"></div>
								<div className="extra-info-headline">
									Includes all the features of Basic and:
								</div>
								<div className="extra-info-features">
									<div className="extra-info-feature">
										{iconGrid} Multiple profiles per social network
									</div>
									<div className="extra-info-feature">
										<i className="icon ion-reply-all reverse" /> Echo: Power Schedule Content
									</div>
									<div className="extra-info-feature">
										<i className="icon ion-paper-airplane"></i> Faster feed updates
									</div>
								</div>
							</div>
						</div>
						<div className="plan-radio" data-plan={constants.PUB_LEVEL_10} onClick={this.setPlan}>
							<div className="control-wrapper">
								<input type="radio" value={constants.PUB_LEVEL_10} checked={this.props.isAgencyPlusUser(this.state.subscription.level)} data-plan={constants.PUB_LEVEL_10} onChange={this.setPlan}/> Agency+ (250 socials. 1500 feeds.)
							</div>
							<div className={"extra-info " + ((this.props.isAgencyPlusUser(this.state.subscription.level)) ? '' : ' hidden')}>
								<div className="arrow-down"></div>
								<div className="extra-info-headline">
									Includes all the features of Agency and:
								</div>
								<div className="extra-info-features">
									<div className="extra-info-feature">
										<i className="ds-icon icon-everqueue"></i> Everqueue: Recycle Content
									</div>
									<div className="extra-info-feature">
										<i className="icon ion-flash"></i> Content Search & Bulk Import
									</div>
									<div className="extra-info-feature">
										<i className="icon ion-ios-pricetag"></i> Categories
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="plan-change-button-wrapper">
						<button className={planChangeButtonClass} onClick={planChangeAction}>
							{planChangeLabel}
						</button>
					</div>
				</div>
			);
		} else {
			changePlanChevron = (<i className="icon ion-chevron-right"/>);
		}

		changePlanBlock = (
			<div ref={this.planChange} className="change-plan-block">
				<h3 onClick={this.togglePlanChange} role="switch" aria-label="show plans"><i className="fa fa-rocket"></i>{planChangeButtonLabel} {changePlanChevron}</h3>
				{planRadioBlock}
				{termChangeBlock}
				{comparisonLink}
			</div>
		);

		if (!_.isEmpty(this.props.plans.current) && (this.props.plans.current.status.canceled === false)) {
			cancelBlock = (
				<div className="cancel-plan-block">
					<a href="#" onClick={this.cancelPlan}>Cancel your plan</a>
				</div>
			);
		} else if (!_.isEmpty(this.props.plans.current) && (this.props.plans.current.status.canceled === true)) {
			if (!this.props.isFreeUser()) {
				cancelBlock = (
					<div className="cancel-plan-block">
						<a href="#" onClick={this.restartPlan}>Restart your plan</a>
					</div>
				);
			}
		}

		if (this.props.router.location.pathname.match(/compare/)) {
			content = (
				<PricingMatrix
					{...this.props}
					currentSubscription={this.state.subscription}
					plans={this.props.plans.details}
					planDetails={this.state.planDetails}
					onPlanUpdate={this.updatePlan}
					bannerVisible={this.props.bannerVisible}
					closePlanChangeBlock={this.closePlanChange}
					errors={this.state.errors} />
			);
		} else if (this.props.app.loading.SUB_FETCH_PLANS ||
				this.props.app.loading.SUB_FETCH_DETAIL ||
				this.props.app.loading.SUB_FETCH ||
				this.props.app.loading.SUB_UPDATE ||
				this.props.app.loading.SUB_ADDON_UPDATE ||
				 _.isEmpty(this.props.plans.details)) {
			content = <Loading />;
		} else if (this.props.user.plan.status !== undefined && this.props.user.plan.status.canceled === true) {
			content = (
				<div>
					<UpgradePricing
						{...this.props}
						onAddOnUpdate={this.f}
						subscriptionUpdate={this.changePlan}
						errors={this.state.errors}
						newSubscription={this.createSubscription}
						setRequestParams={this.setRequestParams}
						togglePlanChange={this.togglePlanChange}
						promoClick={this.promoClick} />
					<div className="cancelation-block">
						<h2>Your plan will not renew</h2>
						<p>Rest assured, it will not renew at the end of your current trial or billing period.</p>
						<p>Until then you can continue to use our service, and if you change your mind, just hit the 'Restart your plan' link below.</p>
					</div>
					{cancelBlock}
				</div>
			);
		} else if (!_.isEmpty(this.props.plans.current) && this.props.router.location.pathname.match(/plus/) && this.state.errors === null) {
			let termShortLabel = 'month',
				newLevel = (this.props.isProUser() || this.props.isBasicUser() || this.props.isStarterUser()) ? constants.PUB_LEVEL_9 : constants.PUB_LEVEL_10,
				addOns = this.props.getAdjustedAddOns(newLevel),
				newPrice = this.props.calculateAddOns([{
					addOn: constants.SUBSCRIPTION_ADDON_SOCIALS,
					quantity: addOns
				}], this.props.plans.details[newLevel]),
				priceLabel = (parseInt(this.state.subscription.term, 10) === constants.SUBSCRIPTION_TERM_ANNUAL) ? newPrice.annualMonthlyPrice : newPrice.price,
				priceInfo = (parseInt(this.state.subscription.term, 10) === constants.SUBSCRIPTION_TERM_ANNUAL) ? (
					<div className="price-info">
						Billed Annually
					</div>
				) : null,
				termButtons = (
					<div className="term-buttons">
		                <div className="term-button single" onClick={(e) => {
								this.plusUpgrade(e, newLevel);
							}} role="button" aria-label='upgrade to plus'>
		                    <div className="term-selector selected">
								<div className="term">
									{newPrice.outputs} Socials and {newPrice.inputs} Feeds
								</div>
		                        <div className="price">
		                            <FormattedNumber value={priceLabel} style="currency" currency="USD"/> / {termShortLabel}
		                        </div>
								{priceInfo}
		                    </div>
		                </div>
					</div>
				);

			content = (
				<PlanDetailBlock
					{...this.props}
					context="upgrade"
					currentPlan={newLevel}
					currentTerm={this.state.subscription.term}
					termButtons={termButtons}
					goToSignup={() => {}}
					startUpgrade={(e) => {
						this.plusUpgrade(e, newLevel);
					}}
					processing={false} />
			);

			return (
				<div className="plus-upgrade">
					<main className="subscription-content-block">
						{content}
					</main>
				</div>
			);
		} else if (legacyPlans.indexOf(parseInt(this.props.user.detail.pubLevel)) !== -1) {
			content = (
				<div>
					<LegacyPricing
						{...this.props}
						onAddOnUpdate={this.updateSubscriptionAddOns}
						currentSubscription={this.state.subscription}
						planDetails={this.props.plans.details}
						subscriptionUpdate={this.changePlan}
						errors={this.state.errors}
						setRequestParams={this.setRequestParams} />
					{changePlanBlock}
					{cancelBlock}
				</div>
			);
		} else {
			content = (
				<div>
					<UpgradePricing
						{...this.props}
						onAddOnUpdate={this.updateSubscriptionAddOns}
						subscriptionUpdate={this.changePlan}
						errors={this.state.errors}
						newSubscription={this.createSubscription}
						setRequestParams={this.setRequestParams}
						togglePlanChange={this.togglePlanChange}
						promoClick={this.promoClick}  />
					{changePlanBlock}
					{cancelBlock}
				</div>
			);
		}

		return (
			<div className="app-column content main" >
				<main className="content-container">
					{content}
				</main>
			</div>
		);
	}
};

Subscription.displayName = "Subscription";

Subscription.propTypes = {
	bannerVisible: PropTypes.bool
};

Subscription.defaultProps = {
	bannerVisible: false
};

const enhance = compose(
	ComponentWithContext,
	PricingModule
);

export default enhance(Subscription);
